import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Identity } from "../../schema/types/identity/entity";

export const identityApi = createApi({
  reducerPath: "identityApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Identity"],
  endpoints: (builder) => ({
    getIdentity: builder.query<Identity, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({
            url: link,
          });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => {
        return [{ type: "Identity", id: link }];
      },
    }),
  }),
});

export const { useGetIdentityQuery } = identityApi;
